import { FC } from 'react'
import Link from 'next/link'
import { Breadcrumb } from 'rsuite'

import useUrls from '../../services/useUrls'
import { Catalog, Product } from '../../utils/types/Product'
import { removeHomeCategory } from '../../lib/category'
import RaquoRightIcon from '../Icons/RaquoRightIcon'
import { getProductBaseSKU } from '../../lib/text'

import styles from '../../styles/BreadcrumbCategory.module.less'

interface BreadcrumbCategoryProps {
  orderedCategories: Catalog[]
  product: Product
  className?: string
  supplierName?: string
}

const BreadcrumbCategory: FC<BreadcrumbCategoryProps> = (props) => {
  const { orderedCategories, product, supplierName, className } = props
  const { urlT } = useUrls()
  const topLevelCategoryCode = orderedCategories.find((category) => category['catalog.code'].includes('c_'))?.['catalog.code']

  const sku = product?.['product.code'] || ''
  const baseSKU = getProductBaseSKU(product)
  const categories = removeHomeCategory(orderedCategories)

  return (
    <Breadcrumb
      maxItems={10}
      separator={<RaquoRightIcon />}
      className={`${styles['category-breadcrumbs-container']} ${className} padding-top-zero`}
    >
      {categories
        // Only include top 3 category levels
        .filter((category) => Number(category?.['catalog.level']) < 4)
        .map((category) => {
          const isTopLevelCategory = category['catalog.code'] === topLevelCategoryCode

          return (
            <Breadcrumb.Item
              key={category['catalog.code']}
              as={Link}
              href={isTopLevelCategory
                ? urlT(`/products/category/${topLevelCategoryCode}`)
                : urlT(`/products/category/${topLevelCategoryCode}/${category['catalog.code']}`)}
            >
              {category['catalog.label']}
            </Breadcrumb.Item>
          )
        })}

      <Breadcrumb.Item
        active
        data-testid="breadcrumb-sku"
        className="breadcrumb-sku"
      >
        <span>
          {`${supplierName} ${baseSKU} (${sku})`}
        </span>
      </Breadcrumb.Item>
    </Breadcrumb>
  )
}

export default BreadcrumbCategory
